import React, { useState } from 'react';

interface IOption<ValueType> {
  id: string;
  label: string;
  value: ValueType;
}
interface IAutoCompleteV2Props<ValueType> {
  writtenStreet: string;
  options?: IOption<ValueType>[];
  isLoading?: boolean;
  suggestionsListBlockStyle?: object;
  renderInput: (ValueType) => React.ReactElement<any>;
  handleSelect: (ValueType) => void;
  onCustomKeyDown?: (e: React.KeyboardEvent) => void;
  onCustomFocus?: () => void;
}

export type IAutoCompleteV2<ValueType = any> = React.FC<
  IAutoCompleteV2Props<ValueType>
>;

const AutoCompleteV2: IAutoCompleteV2 = ({
  writtenStreet,
  options,
  isLoading,
  suggestionsListBlockStyle,
  renderInput,
  handleSelect,
  onCustomKeyDown,
  onCustomFocus,
}) => {
  const [areSuggestionsVisible, setAreSuggestionsVisible] = useState(false);
  const getSuggestedOptionMatching = (
    optionLabel: string | undefined,
  ): string => {
    if (!optionLabel) {
      return '';
    }

    const splitted = optionLabel.split(new RegExp(`^${writtenStreet}`, 'i'));

    if (splitted.length === 1) {
      return `<span>${splitted[0]}</span>`;
    }

    const joined = splitted[1];

    return optionLabel.replace(joined, `<span>${joined}</span>`);
  };

  return (
    <>
      {renderInput({
        onKeyDown: (e: React.KeyboardEvent) => {
          onCustomKeyDown?.(e);

          if (e.key === 'Enter' && areSuggestionsVisible) {
            setAreSuggestionsVisible(false);
          } else if (!areSuggestionsVisible) {
            setAreSuggestionsVisible(true);
          }
        },
        onFocus: () => {
          onCustomFocus?.();
          setAreSuggestionsVisible(true);
        },
      })}
      {areSuggestionsVisible && options && options.length > 0 && (
        <ul
          className="tw-mt-3 tw-px-4 tw-py-2"
          style={suggestionsListBlockStyle}
        >
          {isLoading ? (
            <li>Chargement...</li>
          ) : (
            options.map((option) => (
              <li
                data-testid="AddressForm-Input-suggestion"
                key={option.id}
                className="tw-lf-body-regular-md tw-mb-8 tw-cursor-pointer tw-pl-1 tw-transition-all tw-duration-[0.3s] tw-ease-[ease] [&_span]:tw-lf-body-bold-md hover:tw-bg-beige-200"
                onMouseDown={() => handleSelect(option.value)}
                onTouchStart={() => handleSelect(option.value)}
                dangerouslySetInnerHTML={{
                  __html: getSuggestedOptionMatching(option.label),
                }}
              ></li>
            ))
          )}
        </ul>
      )}
    </>
  );
};

export default AutoCompleteV2;
